import { LinkButton as NetfrontLinkButton } from '@netfront/ui-library';

import { LinkButtonProps } from './LinkButton.interfaces';

const LinkButton = (props: LinkButtonProps) => {
  return <NetfrontLinkButton {...props} />;
};

export { LinkButton };
